import React from "react";
import "./Damper.css";


function Damper({

tag="DAM-001",

x=100,
y=100,

width=120,
height=20,

opening=0,

}){


/*
=========================
DAMER ROTATION LOGIC
=========================

0%   = 0 degree
100% = 90 degree

*/

const rotation =
(opening / 100) * 90;



return (

<div

className="damper-container"

style={{

position:"absolute",

left:x,
top:y,

width,
height:width,

}}


>



<svg

width={width}

height={width}

viewBox="0 0 200 200"

>



{/* =====================
     DAMER BODY
===================== */}



{/* =====================
     ROTATING BLADE
===================== */}


<g

transform={`rotate(${rotation} 100 100)`}

style={{

transition:"0.5s ease"

}}

>


<rect

x="40"

y="96"

width="120"

height="10"

rx="3"

className="damper-blade"

/>



</g>





{/* =====================
      CENTER PIVOT
===================== */}


<circle

cx="100"

cy="100"

r="18"

className="damper-pivot"

/>



<circle

cx="100"

cy="100"

r="6"

className="damper-center"

/>



</svg>


</div>


);

}


export default Damper;